import { RouterProvider } from 'react-router-dom';

import { AppProviders } from './app/providers';
import { router } from './app/router';

/**
 * Main App component
 * Intent: Configure React Query, tRPC, routing, and authentication for the TEO property management platform
 * Implements the user onboarding workflow from the PlantUML specification
 */
function App() {
  const appConfig = window.APP_CONFIG;
  if (!appConfig) {
    return <div>APP_CONFIG is not defined</div>;
  }

  return (
    <AppProviders appConfig={appConfig}>
      <RouterProvider router={router} />
    </AppProviders>
  );
}

export default App;
